import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MinimalCatalogRecord} from '@app/my-account/item-requests/table-column-components/item-request-title.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {Hold} from '@store/holds/holds.types';
import {CombinedCoverTitleDetailComponent} from '@lib/components/combined-cover-title-detail/combined-cover-title-detail.component';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {HoldPositionComponent} from '@app/my-account/holds/hold-position/hold-position.component';

@Component({
  selector: 'px-combined-title-details-position-column',
  host: {
    class: 'text-wrap',
  },
  template: `
    <div class="flex flex-col">
      <px-combined-cover-title-detail
        [catalogRecord]="catalogRecord"
        [detail1]="selectors.materialTypeDescriptionFor(hold) | select"
        [detail2]="selectors.pickupBranchNameFor(hold) | select"
        detailTextSizeClasses="text-body-medium"
        [showCover]="false"
      />
      <px-hold-position
        [status]="selectors.statusFor(hold) | select:'HELD'"
        [queueIndex]="selectors.queueIndexAsStringFor(hold) | select:'0'"
        [copiesCount]="selectors.circulatingCopiesFor(hold) | select:0"/>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, CombinedCoverTitleDetailComponent, HoldPositionComponent]
})
export class CombinedTitleDetailsPositionColumnComponent {
  @Input({required: true}) public hold: Hold;
  @Input({required: true}) public catalogRecord: MinimalCatalogRecord;
  public readonly selectors = HoldsSelectors.OnHold;
}
